import React from 'react'

const containerStyles = {
    width: '100%',
    height: '60vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    padding: '20px',
    boxSizing: 'border-box'
}

const cardStyles = {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '60px 40px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e5e7eb',
    textAlign: 'center',
    maxWidth: '500px',
    width: '100%',
    margin: '0 auto'
}

const iconStyles = {
    width: '80px',
    height: '80px',
    backgroundColor: '#fdebcfff',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 30px auto',
    color: '#d97706',
    fontSize: '36px'
}

const titleStyles = {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1f2937',
    marginBottom: '16px',
    lineHeight: '1.2'
}

const messageStyles = {
    fontSize: '16px',
    color: '#6b7280',
    lineHeight: '1.6',
    marginBottom: '30px'
}

const UnauthorizedAccess = () => {

  return (
    <div style={containerStyles}>
      <div style={cardStyles}>
        <div style={iconStyles}>
            🔒
        </div>
        <h1 style={titleStyles}>Access Denied</h1>
        <p style={messageStyles}>
          Sorry, you don't have permission to access this page. 
        </p>
      </div>
    </div>
  )
}

export default UnauthorizedAccess
